import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Set token from localStorage
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Providers (Prestadores/Fornecedores)
export const getProviders = () => axios.get(`${API_URL}/providers`);
export const getProvider = (id) => axios.get(`${API_URL}/providers/${id}`);
export const createProvider = (data) => axios.post(`${API_URL}/providers`, data);
export const updateProvider = (id, data) => axios.put(`${API_URL}/providers/${id}`, data);
export const deleteProvider = (id) => axios.delete(`${API_URL}/providers/${id}`);
export const getProviderFinancialSummary = (id) => axios.get(`${API_URL}/providers/${id}/financial-summary`);

// Notification Templates
export const getNotificationTemplates = () => axios.get(`${API_URL}/notification-templates`);
export const updateNotificationTemplate = (key, data) => axios.put(`${API_URL}/notification-templates/${key}`, data);
export const resetNotificationTemplate = (key) => axios.delete(`${API_URL}/notification-templates/${key}`);

// Send Custom Notification
export const sendCustomNotification = (data) => axios.post(`${API_URL}/notifications/send`, data);

// Users list (for notification targeting)
// getUsers already defined above

// Users
export const getUsers = () => axios.get(`${API_URL}/users`);
export const createUser = (data) => axios.post(`${API_URL}/users`, data);
export const updateUser = (id, data) => axios.put(`${API_URL}/users/${id}`, data);
export const deleteUser = (id) => axios.delete(`${API_URL}/users/${id}`);

// Projects
export const getProjects = () => axios.get(`${API_URL}/projects`);
export const getProject = (id) => axios.get(`${API_URL}/projects/${id}`);
export const createProject = (data) => axios.post(`${API_URL}/projects`, data);
export const updateProject = (id, data) => axios.put(`${API_URL}/projects/${id}`, data);
export const deleteProject = (id) => axios.delete(`${API_URL}/projects/${id}`);
export const addClientToProject = (projectId, data) => axios.post(`${API_URL}/projects/${projectId}/clients`, data);
export const addAssignmentToProject = (projectId, data) => axios.post(`${API_URL}/projects/${projectId}/assignments`, data);

// Cost Centers
export const getCostCenters = () => axios.get(`${API_URL}/cost-centers`);
export const createCostCenter = (data) => axios.post(`${API_URL}/cost-centers`, data);
export const updateCostCenter = (id, data) => axios.put(`${API_URL}/cost-centers/${id}`, data);
export const addServiceToCostCenter = (costCenterId, data) => axios.post(`${API_URL}/cost-centers/${costCenterId}/services`, data);
export const downloadCostCenterTemplate = () => {
  return axios.get(`${API_URL}/cost-centers/template/download`, {
    responseType: 'blob'
  });
};
export const importCostCenters = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API_URL}/cost-centers/import`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const deleteAllCostCenters = () => axios.delete(`${API_URL}/cost-centers`);
export const deleteCostCenter = (id) => axios.delete(`${API_URL}/cost-centers/${id}`);

// Financial Launches
export const getFinancialLaunches = () => axios.get(`${API_URL}/financial-launches`);
export const getFinancialLaunch = (id) => axios.get(`${API_URL}/financial-launches/${id}`);
export const createFinancialLaunch = (data) => axios.post(`${API_URL}/financial-launches`, data);
export const createDirectLaunch = (data) => axios.post(`${API_URL}/financial-launches/direct`, data);
export const uploadReceipt = (launchId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API_URL}/financial-launches/${launchId}/receipt`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const uploadDirectReceipt = (groupId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API_URL}/financial-launches/direct/${groupId}/receipt`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const confirmPayment = (launchId) => axios.post(`${API_URL}/financial-launches/${launchId}/confirm-payment`);

// Settings
export const getSettings = () => axios.get(`${API_URL}/settings`);
export const updateSettings = (data) => axios.put(`${API_URL}/settings`, data);
export const uploadLogo = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API_URL}/settings/logo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// Empreitas (Sub-obras)
export const getProjectEmpreitas = (projectId) => axios.get(`${API_URL}/projects/${projectId}/empreitas`);
export const getEmpreita = (id) => axios.get(`${API_URL}/empreitas/${id}`);
export const createEmpreita = (data) => axios.post(`${API_URL}/empreitas`, data);
export const updateEmpreita = (id, data) => axios.put(`${API_URL}/empreitas/${id}`, data);
export const deleteEmpreita = (id) => axios.delete(`${API_URL}/empreitas/${id}`);
export const uploadEmpreitaContract = (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API_URL}/empreitas/${id}/contract`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const getProviderEmpreitas = () => axios.get(`${API_URL}/provider/empreitas`);
